import type { Household, HouseholdDependant } from '@api/btlApplicationForm/types';

// Rows pass through whole — nulls included, so untouched legacy rows survive the round trip back
// through `mapOoExpensesFormValuesToHousehold`. The API sends dateOfBirth as a full ISO timestamp,
// and an untouched date field submits its initial value verbatim, so the timestamp is narrowed here
// to the YYYY-MM-DD the write DTO accepts. The date part is sliced off the string rather than
// parsed, so no timezone can shift it to the neighbouring day.
function toFormDependants(dependants?: HouseholdDependant[]): HouseholdDependant[] | undefined {
  return dependants?.map(dependant => ({
    ...dependant,
    dateOfBirth: dependant.dateOfBirth ? dependant.dateOfBirth.split('T')[0] : dependant.dateOfBirth,
  }));
}

export function mapHouseholdToOoExpensesFormValues(household?: Household): Record<string, unknown> {
  if (!household) {
    return {};
  }

  return {
    dependants: toFormDependants(household.dependants),
    income: household.income,
    declaredExpenditure: household.declaredExpenditure,
    creditCommitments: household.creditCommitments,
    occupiers: household.occupiers ?? [],
  };
}
